<template>
  <div class="index">
    <div class="navs-wrapper">
      <div
        v-for="item in navs"
        :key="item.id"
        class="nav-item"
        @click="$router.push(item.href)"
        :style="`background-image: url(${baseUrl}${item.imgurl})`"
        >
          {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters([ 'menu' ]),
    baseUrl() {
      return 'https://honjo-1319856470.cos.ap-shanghai.myqcloud.com/dist'
      // return `${window.location.origin}${this.$utils.siteBase()}`
    },
    navs() {
      const parentId = 227
      const tagItem = this.menu.find(i => i.id === parentId)

      return tagItem ? tagItem.children || [] : []
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
  .index {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .navs-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      width: 1200px;
      .nav-item {
        width: 240px;
        height: 240px;
        margin: 0 20px;
        cursor: pointer;
        background-size: 100%;
        background-repeat: no-repeat;
        text-align: center;
        line-height: 380px;
      }
    }
  }
</style>